import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommittedTransactionVolumeQueryVariables = Types.Exact<{
  store_uuid: Types.Scalars['ID'];
}>;


export type CommittedTransactionVolumeQuery = { __typename?: 'Query', committedTransactionVolume?: { __typename?: 'CommittedTransactionVolume', id: string, store_uuid: string, committed_volume: number, discount_per_transaction_in_cents: number } | null };


export const CommittedTransactionVolumeDocument = gql`
    query committedTransactionVolume($store_uuid: ID!) {
  committedTransactionVolume(store_uuid: $store_uuid) {
    id
    store_uuid
    committed_volume
    discount_per_transaction_in_cents
  }
}
    `;

/**
 * __useCommittedTransactionVolumeQuery__
 *
 * To run a query within a React component, call `useCommittedTransactionVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommittedTransactionVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommittedTransactionVolumeQuery({
 *   variables: {
 *      store_uuid: // value for 'store_uuid'
 *   },
 * });
 */
export function useCommittedTransactionVolumeQuery(baseOptions: Apollo.QueryHookOptions<CommittedTransactionVolumeQuery, CommittedTransactionVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommittedTransactionVolumeQuery, CommittedTransactionVolumeQueryVariables>(CommittedTransactionVolumeDocument, options);
      }
export function useCommittedTransactionVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommittedTransactionVolumeQuery, CommittedTransactionVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommittedTransactionVolumeQuery, CommittedTransactionVolumeQueryVariables>(CommittedTransactionVolumeDocument, options);
        }
export type CommittedTransactionVolumeQueryHookResult = ReturnType<typeof useCommittedTransactionVolumeQuery>;
export type CommittedTransactionVolumeLazyQueryHookResult = ReturnType<typeof useCommittedTransactionVolumeLazyQuery>;
export type CommittedTransactionVolumeQueryResult = Apollo.QueryResult<CommittedTransactionVolumeQuery, CommittedTransactionVolumeQueryVariables>;